import axios from 'axios';
import URLS from '../../utils/constants/URLS';
import * as API from '../api';

import {
  SET_ADD_LOCATION,
  SET_LOCATIONS,
  FETCH_LOCATIONS_FAILURE,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_START,
  ADD_LOCATION_START,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_FAILURE,
  INITIAL_LOCATIONS,
  SET_CURRENT_LOCATION,
  SET_EDIT_LOCATION,
  FETCH_LOCATIONS_LIST_START,
  FETCH_LOCATIONS_LIST_SUCCESS,
  FETCH_LOCATIONS_LIST_FAILURE,
} from './LocationTypes';
import { fetchDashboardDataStartAsync } from '../dashboard/DashboardAction';

// Action creators using standard Redux pattern
export const setAddLocation = (showModal) => ({
  type: SET_ADD_LOCATION,
  payload: showModal,
});

export const addLocationStart = () => ({
  type: ADD_LOCATION_START,
});

export const addLocationSuccess = () => ({
  type: ADD_LOCATION_SUCCESS,
});

export const addLocationFailure = (error) => ({
  type: ADD_LOCATION_FAILURE,
  payload: error,
});

export const setLocations = (locations) => ({
  type: SET_LOCATIONS,
  payload: locations,
});

export const fetchLocationsStart = () => ({
  type: FETCH_LOCATIONS_START,
});

export const fetchLocationsSuccess = (locations) => ({
  type: FETCH_LOCATIONS_SUCCESS,
  payload: locations,
});

export const fetchLocationsFailure = (errorMessage) => ({
  type: FETCH_LOCATIONS_FAILURE,
  payload: errorMessage,
});

export const initializeLocations = () => ({
  type: INITIAL_LOCATIONS,
});

export const fetchLocationsListStart = () => ({
  type: FETCH_LOCATIONS_LIST_START,
});

export const fetchLocationsListSuccess = (locationsList) => ({
  type: FETCH_LOCATIONS_LIST_SUCCESS,
  payload: locationsList,
});

export const fetchLocationsListFailure = (errorMessage) => ({
  type: FETCH_LOCATIONS_LIST_FAILURE,
  payload: errorMessage,
});

export const setEditLocation = (isEditLocation) => ({
  type: SET_EDIT_LOCATION,
  payload: isEditLocation,
});

export const setCurrentLocation = (location) => ({
  type: SET_CURRENT_LOCATION,
  payload: location,
});

export const getLocationsAsync = () => {
  return (dispatch) => {
    dispatch(fetchLocationsStart());
    axios
      .get(URLS.locations)
      .then((response) => {
        dispatch(fetchLocationsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchLocationsFailure(error.message || 'Failed to fetch locations'));
      });
  };
};

export const getLocationsListAsync = () => {
  return (dispatch) => {
    dispatch(fetchLocationsListStart());
    API.get(URLS.locationsList)
      .then((response) => {
        dispatch(fetchLocationsListSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchLocationsListFailure(error.message || 'Failed to fetch locations list'));
      });
  };
};

export const addLocationAsync = (locationData, setSuccessMessage, setLocationInfo, setErrors) => async (dispatch) => {
  try {
    setSuccessMessage('');
    setErrors({});
    dispatch(addLocationStart());
    dispatch(setAddLocation(true));
    API.post(URLS.locations, locationData)
      .then(() => {
        // Dispatch action to store locations with metadata
        dispatch(fetchDashboardDataStartAsync());
        dispatch(addLocationSuccess());
        dispatch(getLocationsAsync());
        setLocationInfo({
          name: '',
          first_name: '',
          middle_name: '',
          last_name: '',
          admin_email: '',
          revenue_split: '',
        });
        setSuccessMessage('Location added successfully! An invitation email has been sent to the admin.');
        dispatch(getLocationsListAsync());
      })
      .catch((error) => {
        setSuccessMessage('');
        dispatch(addLocationFailure(error.message || 'Failed to add location'));
        setErrors({ detail: error.response.data.detail ?? 'Failed to add location' });
      });
  } catch (error) {
    dispatch(setAddLocation(false));
  }
};

export const updateLocationAsync =
  (locationData, setSuccessMessage, setLocationInfo, setErrors) => async (dispatch) => {
    try {
      setSuccessMessage('');
      setErrors({});
      dispatch(addLocationStart());
      dispatch(setAddLocation(true));
      API.patch(`${URLS.locations}${locationData.id}/`, {
        name: locationData.name,
        revenue_split: locationData.revenue_split,
      })
        .then((response) => {
          dispatch(addLocationSuccess());
          dispatch(getLocationsAsync());
          setLocationInfo((prev) => ({ ...prev, name: response.data.name }));
          setSuccessMessage('Location updated successfully!');
          dispatch(getLocationsListAsync());
        })
        .catch((error) => {
          setSuccessMessage('');
          dispatch(addLocationFailure(error.message || 'Failed to update location'));
          setErrors({ detail: error.response.data.detail ?? 'Failed to update location' });
        });
    } catch (error) {
      dispatch(setAddLocation(false));
    }
  };
